import React, { useEffect, useRef, useState } from "react";
import classes from "./ModalAssignServices.module.scss";
import { SubmitHandler, useForm } from "react-hook-form";

import classNames from "classnames";
import modalBase from "../../../ModalBase/ModalBase.module.scss";
import { Button } from "../../Button/Button";
import { CustomTextField } from "../../CustomTextField/CustomTextField";
import { crossIcon } from "../../../../assets/icons";
import { AssignedServicesType } from "../../../../pagesAdmin/EmployersPage/EmployersPage";
import { SearchTextField } from "../../SearchTextField/SearchTextField";
import {
  WorkingPlacesBodyType,
  WorkingPlacesRequestBodyType,
} from "../../../../types/Admin/WorkingPlacesTypes";
import { WorkPlaceType } from "../../../../pagesAdmin/WorkplacesPage/WorkplacesPage";
import { workingPlaceType } from "../../Tables/WorkingPlacesTable/WorkingPlacesTable";

type FormData = {
  searchText: string;
};

type serviceType = {
  id: number;
  nameRu: string;
};

type ModalAccessLevelsProps = {
  isActive: boolean;
  setActive: (value: boolean) => void;
  allSystemTopics: AssignedServicesType[];
  assignedServices?: AssignedServicesType[];
  setAssignedServices: (servicesList: AssignedServicesType[]) => void;
  availableServices?: AssignedServicesType[];
  setAvailableServices: (servicesList: AssignedServicesType[]) => void;
  setBackStage: (stage: boolean) => void;
  setModalActive: (status: boolean) => void;
  createWorkingPlace: (item: WorkingPlacesBodyType) => void;
  editWorkingPlace: (item: WorkingPlacesRequestBodyType) => void;
  isLoadingEditWorkingPlace: boolean;
  isLoadingCreateWorkingPlace: boolean;
  agentsRequestData: WorkPlaceType;
  setAgentsRequestData: (requestBody: WorkPlaceType | null) => void;
  setActiveRowData: (value: null | workingPlaceType) => void;
  isCreateMode: boolean;
  setIsCreateMode: (status: boolean) => void;
  /** true если темы не удалось загрузить (например 403) */
  isTopicsForbidden?: boolean;
};

export const ModalAccessLevels = ({
  isActive,
  setActive,
  availableServices: list1 = [],
  setAvailableServices: setList1,
  assignedServices: list2 = [],
  setAssignedServices: setList2,
  allSystemTopics,
  agentsRequestData,
  isCreateMode,
  setIsCreateMode,
  isLoadingEditWorkingPlace,
  isLoadingCreateWorkingPlace,
  setAgentsRequestData,
  createWorkingPlace,
  editWorkingPlace,
  setBackStage,
  setModalActive,
  setActiveRowData,
  isTopicsForbidden = false,
}: ModalAccessLevelsProps) => {
  const [servicesArray, setServicesArray] = useState(allSystemTopics);
  const modalRef = useRef<HTMLDivElement>(null);

  const [searchText, setSearchText] = useState("");
  const filteredList = React.useMemo(() => {
    const q = searchText.trim().toLowerCase();
    if (!q) return list1;
    const isNumeric = /^\d+$/.test(q);
    return list1.filter((item) => {
      const nameMatch = item.nameRu?.toLowerCase().includes(q);
      const idMatch = isNumeric ? String(item.id).includes(q) : false;
      return Boolean(nameMatch || idMatch);
    });
  }, [list1, searchText]);

  const moveItem = (
    item: serviceType,
    fromList: AssignedServicesType[],
    toList: AssignedServicesType[],
  ) => {
    const index = fromList.indexOf(item);
    const updatedFromList = [
      ...fromList.slice(0, index),
      ...fromList.slice(index + 1),
    ];
    const updatedToList = [...toList, item];
    fromList === list1 ? setList1(updatedFromList) : setList2(updatedFromList);
    fromList === list1 ? setList2(updatedToList) : setList1(updatedToList);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  function filterArray(
    arr1: AssignedServicesType[],
    arr2: AssignedServicesType[],
  ) {
    return arr1.filter((obj1) => !arr2.some((obj2) => obj1.id == obj2.id));
  }

  const topicsByBranchQueue = React.useMemo(() => {
    const branchIds = agentsRequestData?.branchIds ?? [];
    const queueIds = agentsRequestData?.queueIds ?? [];
    if (branchIds.length === 0 && queueIds.length === 0) return allSystemTopics;
    const filtered = allSystemTopics.filter((row) => {
      const rowBranchIds = row.branchIds ?? [];
      const rowQueueIds = row.queueIds ?? [];
      const branchMatch =
        branchIds.length === 0 ||
        rowBranchIds.length === 0 ||
        rowBranchIds.some((b) => branchIds.includes(b));
      const queueMatch =
        queueIds.length === 0 ||
        rowQueueIds.length === 0 ||
        rowQueueIds.some((q) => queueIds.includes(q));
      return Boolean(branchMatch && queueMatch);
    });

    return filtered;
  }, [
    allSystemTopics,
    agentsRequestData?.branchIds,
    agentsRequestData?.queueIds,
  ]);

  useEffect(() => {
    const filteredSystemTopics = filterArray(topicsByBranchQueue, list2 ?? []);
    setList1(filteredSystemTopics);
  }, [list2, topicsByBranchQueue]);

  useEffect(() => {
    setServicesArray(allSystemTopics);
  }, [allSystemTopics]);

  const { register, handleSubmit } = useForm<FormData>({
    mode: "onChange",
    defaultValues: {
      searchText: "",
    },
  });
  const filterServices = (searchValue: string): void => {
    const filteredItems = servicesArray?.filter((item) => {
      return item.nameRu.toLowerCase().includes(searchValue.toLowerCase());
    });
    setServicesArray(filteredItems);
  };

  const onSubmit: SubmitHandler<FormData> = async () => {
    const agentsRequestBody = {
      type: agentsRequestData.type,
      description: agentsRequestData.description,
      digitalDisplayIp: agentsRequestData.digitalDisplayIp,
      officeNumber: agentsRequestData.officeNumber || null,
      windowNumber: agentsRequestData.windowNumber || null,
      users: agentsRequestData.assignedEmployeesIds || [],
      topics: list2.map((e: serviceType) => e.id),
      queueName: agentsRequestData.queueName ?? null,
      ...(agentsRequestData.branchIds?.length && {
        branchIds: agentsRequestData.branchIds,
      }),
      ...(agentsRequestData.queueIds?.length && {
        queueIds: agentsRequestData.queueIds,
      }),
    };

    setBackStage(false);
    if (agentsRequestData?.id) {
      editWorkingPlace({
        requestBody: agentsRequestBody,
        id: agentsRequestData.id,
      });
    }
    if (!agentsRequestData?.id) {
      createWorkingPlace(agentsRequestBody);
    }
    setActiveRowData(null);
  };

  const handleClickOutside = (event: MouseEvent): void => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setActive(false);
      setBackStage(false);
      setAgentsRequestData(null);
      setList2([]);
      setIsCreateMode(false);
      setActiveRowData(null);
    }
  };

  const handleClickBack = () => {
    setActive(false);
    setModalActive(true);
    setBackStage(true);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div
      className={classNames(modalBase.modal, { [modalBase.active]: isActive })}
    >
      <div
        className={classNames(
          modalBase.container,
          classes.unlimitedAgentContainer,
          classes.assignServicesListHeight300,
        )}
        ref={modalRef}
      >
        <form className={classes.unlimitedAgentForm}>
          {(isLoadingEditWorkingPlace || isLoadingCreateWorkingPlace) && (
            <div className={classes.load}>
              <div className={classes.loadContent}>
                <p>Cохранение...</p>
              </div>
            </div>
          )}
          {isTopicsForbidden && (
            <div style={{ marginBottom: 12, color: "#d92d20" }}>
              Нет доступа к списку услуг (тем). Обратитесь к администратору для
              выдачи прав.
            </div>
          )}
          <h2 className={modalBase.title}>
            {isCreateMode
              ? "Создание рабочего места"
              : "Редактирование рабочего места"}
          </h2>
          <div>
            <div className={classes.addContainer}>
              <div className={classes.searchItemContainer}>
                <SearchTextField
                  {...register("searchText")}
                  name="searchText"
                  labelName={"Добавить услугу"}
                  placeholder={"Введите название"}
                  clearInput={(): void => {
                    setSearchText("");
                    filterServices("");
                  }}
                  value={searchText}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    handleSearch(e)
                  }
                >
                  {filteredList.map((item) => (
                    <div
                      key={item.id}
                      className={classes.serviceItem}
                      onClick={() => moveItem(item, list1, list2)}
                    >
                      {item.nameRu}
                    </div>
                  ))}
                </SearchTextField>
              </div>
              <div className={classes.addedItemContainer}>
                <CustomTextField
                  labelName={"Добавленные услуги"}
                  disabled={true}
                >
                  {list2.map((item) => (
                    <div
                      key={item.id}
                      className={classes.addedServiceItem}
                      onClick={() => moveItem(item, list2, list1)}
                    >
                      <img src={crossIcon} alt={"cross"} />
                      {item.nameRu}
                    </div>
                  ))}
                </CustomTextField>
              </div>
            </div>
            <div className={classes.buttonsContainer}>
              <Button
                content={"назад"}
                btnStyle={"white"}
                onClick={() => handleClickBack()}
              />
              <div className={classes.mainBtnsContainer}>
                <Button
                  content={"отмена"}
                  btnStyle={"white"}
                  onClick={() => {
                    setActive(false);
                    setBackStage(false);
                    setAgentsRequestData(null);
                    setList2([]);
                    setIsCreateMode(false);
                    setActiveRowData(null);
                  }}
                />
                <Button
                  content={"сохранить"}
                  btnStyle={"blue"}
                  onClick={handleSubmit(onSubmit)}
                  isLoading={
                    isLoadingEditWorkingPlace || isLoadingCreateWorkingPlace
                  }
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
